import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import { Description, Title, TitleSymbol, Wrapper } from './ConferenceDescription.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceDescriptionTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.ABOUT}`}>
            <Title colors={colors}>
                {t('conference.component.description.title')}
                <TitleSymbol colors={colors} />
            </Title>
            <Description dangerouslySetInnerHTML={{ __html: conf?.conference?.anotation }}></Description>
        </Wrapper>
    );
};

export default ConferenceDescriptionTemplate;
